/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
const groups = [
  {
    id: '1111', 
    name: 'Group One',
    members: [
      {id: '528461', fullname: 'Member One'},
      {id: '528462', fullname: 'Member Two'},
      {id: '528463', fullname: 'Member Three'},
      {id: '528464', fullname: 'Member Four'},
      {id: '528465', fullname: 'Member Five'},
      {id: '528466', fullname: 'Member Six'},
      {id: '528467', fullname: 'Member Seven'},
      {id: '528468', fullname: 'Member Eight'},
      {id: '528469', fullname: 'Member Ten'}
    ],
    projects : [
      {id: '85881', title: 'Project One', description: 'This project is prepared for group one, and students have to finish it before deadlines.....................................................'},
      {id: '85882', title: 'Project Two', description: 'This project is prepared for group one, and students have to finish it before deadlines.....................................................'}
    ],
    poster: 'https://images.unsplash.com/photo-1504805572947-34fad45aed93?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Y292ZXIlMjBwaG90b3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60',
    icon: 'https://www.freevector.com/uploads/vector/preview/28523/Group-of-People.jpg'
  },
  {
    id: '1112',
    name: 'Group Two',
    members: [
      {id: '528471', fullname: 'Member One'},
      {id: '528472', fullname: 'Member Two'},
      {id: '528473', fullname: 'Member Three'},
      {id: '528474', fullname: 'Member Four'},
      {id: '528475', fullname: 'Member Five'},
      {id: '528476', fullname: 'Member Six'},
      {id: '528477', fullname: 'Member Seven'},
      {id: '528478', fullname: 'Member Eight'},
      {id: '528479', fullname: 'Member Ten'}
    ],
    projects : [
      {id: '85883', title: 'Project One', description: 'This project is prepared for group two, and students have to finish it before deadlines.....................................................'},
      {id: '85884', title: 'Project Two', description: 'This project is prepared for group two, and students have to finish it before deadlines.....................................................'}
    ],
    poster: 'https://images.unsplash.com/photo-1528465424850-54d22f092f9d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y292ZXIlMjBwaG90b3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60',
    icon: 'https://www.freevector.com/uploads/vector/preview/28523/Group-of-People.jpg'
  },
  {
    id: '1113',
    name: 'Group Three',
    members: [
      {id: '528481', fullname: 'Member One'},
      {id: '528482', fullname: 'Member Two'},
      {id: '528483', fullname: 'Member Three'},
      {id: '528484', fullname: 'Member Four'},
      {id: '528485', fullname: 'Member Five'},
      {id: '528486', fullname: 'Member Six'},
      {id: '528487', fullname: 'Member Seven'},
      {id: '528488', fullname: 'Member Eight'},
      {id: '528489', fullname: 'Member Ten'}
    ],
    projects : [
      {id: '85885', title: 'Project One', description: 'This project is prepared for group three, and students have to finish it before deadlines.....................................................'},
      {id: '85886', title: 'Project Two', description: 'This project is prepared for group three, and students have to finish it before deadlines.....................................................'}
    ],
    poster: 'https://images.unsplash.com/photo-1608408843596-b3119736057c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Y292ZXIlMjBwaG90b3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60',
    icon: 'https://www.freevector.com/uploads/vector/preview/28523/Group-of-People.jpg'
  }
];

export default groups;
